"use client";

/**
 * GuestOnly — renders its children only when the user is NOT authenticated.
 *
 * Use for acquisition microcopy ("5 free credits a month · No card", "Free
 * trial · No card required", etc.) that's noise to logged-in users — they
 * already signed up, they already know the pricing.
 *
 * Renders nothing during the auth "loading" state. That's deliberate: we'd
 * rather show the acquisition copy a beat late than flash it to a
 * logged-in user who finds it patronizing. Most page loads will resolve
 * auth state from localStorage within a tick, so this is invisible to
 * guests in practice.
 *
 * Pairs with <AuditCta>, which handles the matching CTA label swap.
 */

import type { ReactNode } from "react";
import { useAccountState } from "./use-account-state";

export function GuestOnly({ children }: { children: ReactNode }) {
  const state = useAccountState();
  if (state.status !== "anonymous") return null;
  return <>{children}</>;
}
